var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "62tuplh53a",
    d: "M14.646 0c.885 0 1.604.701 1.604 1.563v16.874c0 .862-.719 1.563-1.603 1.563H1.605C.72 20 0 19.298 0 18.436V5.596c0-.543.22-1.075.604-1.46L4.136.606C4.526.215 5.045 0 5.596 0h9.05zm0 1.25h-9.05c-.217 0-.422.084-.575.238L1.488 5.021c-.151.15-.238.36-.238.575v12.84c0 .173.16.314.355.314h13.041c.195 0 .354-.14.354-.313V1.563c0-.172-.159-.313-.354-.313zm-2.771 14.375c.346 0 .625.28.625.625 0 .346-.28.625-.625.625h-7.5c-.345 0-.625-.28-.625-.625 0-.346.28-.625.625-.625h7.5zM8.567 7.058l2.5 2.5c.244.245.244.64 0 .884-.122.122-.282.183-.442.183-.16 0-.32-.061-.442-.183L8.75 9.009v4.793c0 .317-.28.573-.625.573s-.625-.256-.625-.573V9.01l-1.433 1.433c-.245.244-.64.244-.884 0-.244-.245-.244-.64 0-.884l2.5-2.5c.245-.244.64-.244.884 0zM5.625 1.875c.345 0 .625.28.625.625v2.188c0 .86-.701 1.562-1.563 1.562H2.5c-.345 0-.625-.28-.625-.625S2.155 5 2.5 5h2.188C4.86 5 5 4.86 5 4.687V2.5c0-.345.28-.625.625-.625z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-411 -414) translate(385 388) translate(26 24) translate(0 2) translate(.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "irh0mowccb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#62tuplh53a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#62tuplh53a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8A8E96",
    mask: "url(#irh0mowccb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z",
    transform: "translate(-2.5)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.96e42f8efa053f5fd41fafd89c8ea585.svg";
export { ForwardRef as ReactComponent };